/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SequenceNumberForBr } from './SequenceNumberForBr';
import {
    SequenceNumberForBrFromJSON,
    SequenceNumberForBrFromJSONTyped,
    SequenceNumberForBrToJSON,
    SequenceNumberForBrToJSONTyped,
} from './SequenceNumberForBr';

/**
 * 
 * @export
 * @interface SequenceNumbersForBrResponse
 */
export interface SequenceNumbersForBrResponse {
    /**
     * 
     * @type {Array<SequenceNumberForBr>}
     * @memberof SequenceNumbersForBrResponse
     */
    sequenceNumbers?: Array<SequenceNumberForBr>;
}

/**
 * Check if a given object implements the SequenceNumbersForBrResponse interface.
 */
export function instanceOfSequenceNumbersForBrResponse(value: object): value is SequenceNumbersForBrResponse {
    return true;
}

export function SequenceNumbersForBrResponseFromJSON(json: any): SequenceNumbersForBrResponse {
    return SequenceNumbersForBrResponseFromJSONTyped(json, false);
}

export function SequenceNumbersForBrResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceNumbersForBrResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'sequenceNumbers': json['sequenceNumbers'] == null ? undefined : ((json['sequenceNumbers'] as Array<any>).map(SequenceNumberForBrFromJSON)),
    };
}

export function SequenceNumbersForBrResponseToJSON(json: any): SequenceNumbersForBrResponse {
    return SequenceNumbersForBrResponseToJSONTyped(json, false);
}

export function SequenceNumbersForBrResponseToJSONTyped(value?: SequenceNumbersForBrResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sequenceNumbers': value['sequenceNumbers'] == null ? undefined : ((value['sequenceNumbers'] as Array<any>).map(SequenceNumberForBrToJSON)),
    };
}

